// prettier-ignore
const template = (data) => `
    <div class="display__item">
        <article class="card card--case-study ${data.accent}">
            <a href="${data.url}" class="card__link">
                <div class="card__shape"></div>
                <div class="card__image-container">
                    ${data.image?.src ? `<img class="card__image" src="${data.image?.src}" alt="${data.image?.alt}"  />` : ''}
                </div>
                <div class="card__container">
                    <div>
                        ${data.tag ? `<span class="tag">${data.tag}</span>` : ''}
                        ${data.title ? `<h3 class="card__heading">${data.title}</h3>` : ''}
                    </div>
                    <div class="card__cta card__cta--button">
                        <p class="card__cta-text">View case study</p>
                    </div>
                </div>
            </a>
        </article>
    </div>
`
export default template
